export default __webpack_public_path__ + "static/media/webilo-about.e657bed5.svg";